import { getDomainConfig } from '@/config/domainConfig'

const state = {
  domainConfig: null,
  apiConfig: null,
  isPortal: false,
  isAdmin: false
}

const getters = {
  domainConfig: state => state.domainConfig,
  apiConfig: state => state.apiConfig,
  isPortal: state => state.isPortal,
  isAdmin: state => state.isAdmin,
  currentDomain: state => state.domainConfig?.domain || window.location.hostname
}

const mutations = {
  setDomainConfig(state, config) {
    state.domainConfig = config
    state.isPortal = config.isPortal
    state.isAdmin = config.isAdmin
  },
  setApiConfig(state, config) {
    state.apiConfig = config
  },
  initializeConfig(state) {
    const config = getDomainConfig()
    state.domainConfig = config
    state.apiConfig = config.api
    state.isPortal = config.isPortal
    state.isAdmin = config.isAdmin
  }
}

const actions = {
  initializeConfig({ commit }) {
    commit('initializeConfig')
  },
  updateApiConfig({ commit }, config) {
    commit('setApiConfig', config)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
